import React from "react";
import "antd/dist/antd.css";
import { Input } from "antd";

export default function IconInput(props) {
  const {
    label,
    value,
    onChangeText,
    prefix,
    placeholder,
    type,
    loading,
    required,
    invalid,
    errorText,
  } = props;
  const onChangeHandler = (e) => {
    onChangeText(e.target.value);
  };
  return (
    <div className={`dropdown_wrapper${invalid ? " is-invalid" : ""}`}>
      <div>
        {label}
        {required ? <span style={{ color: "#dc2626", marginLeft: 4 }}>*</span> : null}
        :
      </div>
      <Input
        disabled={loading}
        type={type}
        placeholder={placeholder || label}
        prefix={prefix}
        onChange={onChangeHandler}
        value={value}
        status={invalid ? "error" : undefined}
        aria-required={required ? "true" : undefined}
        aria-invalid={invalid ? "true" : undefined}
      />
      {invalid && errorText ? (
        <div style={{ color: "#dc2626", fontSize: 12, marginTop: 4 }} role="alert">
          {errorText}
        </div>
      ) : null}
    </div>
  );
}
